import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { SearchGlassIcon, ClearSearchIcon } from '../../svg/';
import { Flex } from '../../layout/flex';
import { BaseInput } from './base_input';
import Label from '../../typography/label';
import styled from '../../../styles/styled';
import { focus } from '../../../styles/theme';
const Container = styled(Flex)(({ theme }) => ({
    height: 40,
    alignItems: 'center',
    background: theme.colors.grey05,
    borderRadius: 32,
    padding: '8px 16px',
    ':focus-within': focus.shadow,
    '::placeholder': {
        color: theme.colors.grey30,
    },
    ':hover': {
        backgroundColor: theme.colors.hoverBlue,
    },
}));
export const RoundedSearch = ({ name, clearSearch, autoFocus = true, ...rest }) => {
    const value = rest.value?.toString() || '';
    const baseInputRef = useRef(null);
    useEffect(() => {
        if (value) {
            const inputLength = value.length;
            baseInputRef.current.setSelectionRange(inputLength, inputLength);
            baseInputRef.current.focus();
        }
        // only run on initial mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClearSearch = () => {
        if (clearSearch) {
            clearSearch();
            baseInputRef.current?.focus();
        }
    };
    return (_jsxs(Container, { children: [_jsx(SearchGlassIcon, {}), _jsx(Label, { htmlFor: name, screenReaderOnly: true, children: name }), _jsx(BaseInput, { ref: baseInputRef, id: name, autoFocus: autoFocus, name: name, ml: 1, fontSize: 1, ...rest }), value && clearSearch && (_jsx(IconButton, { onClick: handleClearSearch, "aria-label": "Clear search", type: "button", "data-testid": "clear-search", children: _jsx(ClearSearchIcon, {}) }))] }));
};
const IconButton = styled.button({
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
        opacity: 0.7,
    },
});
//# sourceMappingURL=rounded_search.js.map